module.exports = __webpack_public_path__ + "static/media/img50.4a99487d.jpg";